import React from 'react'
import {Box, Link, Paper, Typography} from '@mui/material';

const NotFound = ({style}) => {
  return (
    <Box
      sx={{
        minHeight:'75vh',
        '@media (max-width: 768px)': {
          minWidth: '100%', // Adjust width for smaller screens
          minHeight: '30rem', // Remove fixed height for smaller screens
        },
      }}
    >
      <Paper
        sx={{
          textAlign:'center',
          padding: '1rem'
        }}
      >
        <Typography
          variant='h1'
          sx={{
            margin:'1rem',
            fontSize:'2.5rem'
          }}
        >Page Error</Typography>

        <Typography
          sx={{
            fontSize:'2rem'
          }}
        >We apologize, but the page you are trying to access is currently unavailable. Please click the Button below to return to a valid page. Thank you for your understanding.</Typography>
        <Typography
          variant='h3'
          sx={{
            margin:'1rem',
            padding:'1rem',
            fontSize:'2rem'
          }}
        ><Link href="/">Click me!</Link></Typography>
      </Paper>
    </Box>
  )
}

export default NotFound